import React from 'react'
import { Td } from 'react-super-responsive-table'

function ImageText(props: { row: any, options: any }) {
  const { row, options } = props

  const imageKey = options?.image || "image"
  const textKey = options?.text || "text"

  const image = row[imageKey]
  const text = row[textKey]

  return (
    <div className='flex items-center gap-[15px]  '>
      <img className='w-[60px] m-2  rounded-md'
        src={image || process.env.REACT_APP_DEFAULT_IMAGE} />
      <div className='w-[100%] block truncate overflow-hidden'>  {text}</div>
    </div>
  )
}

export default ImageText